import { DestroyRef, Signal, inject, signal } from '@angular/core';

/** Below this width the rail turns into a drawer opened from the header. */
export const SHELL_NARROW_QUERY = '(max-width: 1023.98px)';

/**
 * Whether the viewport is narrower than the rail breakpoint, updated on
 * resize. Call from an injection context.
 */
export function injectNarrowViewport(): Signal<boolean> {
  const media = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(SHELL_NARROW_QUERY) : null;
  const narrow = signal(media?.matches ?? false);
  if (media) {
    const onChange = (event: MediaQueryListEvent): void => narrow.set(event.matches);
    media.addEventListener('change', onChange);
    inject(DestroyRef).onDestroy(() => media.removeEventListener('change', onChange));
  }
  return narrow.asReadonly();
}
